// directives/style.js
export const style = {
    selector: '[data-style]',
    reactive: true,
    run(el, data, root) { 
        const key = el.getAttribute('data-style');
        el.style.cssText = data[key] || '';

        if (!root.__bindings) root.__bindings = {};
        if (!root.__bindings[key]) root.__bindings[key] = [];
        root.__bindings[key].push((val) => {
            el.style.cssText = val;
        });
    }
};